<div class="content">
	@if (user?.flgIam) {
		<form
			[formGroup]="changePasswordForm"
			enctype="application/x-www-form-urlencoded"
		>
			<section class="form">
				<h2>{{ "changePassword.private.changePassword" | translate }}</h2>
				<div class="field col-sm-12">
					<p
						dir="ltr"
						[innerHTML]="'passwordFormat' | translate"
					></p>
				</div>
				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_newPwd">{{ "changePassword.private.newPassword" | translate }}</label>
					<input
						type="password"
						id="b2bCambioPwd_newPwd"
						name="b2bCambioPwd_newPwd"
						formControlName="password"
						maxlength="30"
					/>
				</div>
				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_confirmPwd">{{ "changePassword.private.confirmPassword" | translate }}</label>
					<input
						type="password"
						id="b2bCambioPwd_confirmPwd"
						name="b2bCambioPwd_confirmPwd"
						formControlName="confPassword"
						maxlength="30"
					/>
				</div>
				<div class="col-sm-12 text-center">
					<a
						[class.disabled]="changePasswordForm.invalid || !isValid()"
						(click)="changePassword()"
						class="btn btn-red"
					>
						{{ "changePassword.private.change" | translate }}
					</a>
				</div>
			</section>
		</form>
	}
</div>